export const environment = {
  local: false,
  production: false,
  development: true,
  webApp: {
    baseUrl: 'https://suite-dev.newroom-connect.com'
  },
  api: {
    baseUrl: 'https://data-api-dev.newroom-connect.com'
  },
  auth: {
    baseUrl: 'https://auth-api-dev.newroom-connect.com'
  },
  websocketServer: {
    baseUrl: 'wss://data-api-dev.newroom-connect.com'
  },
  customDomainRouting: {
    enabled: true,
    baseDomain: 'newroom-connect.com'
  },
  config: {
    googleAnalytics: {
      settings: {
        // eslint-disable-next-line camelcase
        anonymize_ip: true
      }
    }
  },
  pixelStream: {
    baseUrl: 'https://streams.vagon.io/streams/',
    sdkUrl: 'https://app.vagon.io/vagonsdk.js'
  },
  chatWidget: {
    cdnUrl: 'https://d2mfpyhdpg6h1w.cloudfront.net/widget/latest/chat-widget.js',
    embeddingModelId: 'text-embedding-3-large',
    embeddingModelApiVersion: '2024-02-01',
    llmId: 'gpt-4o',
    llmApiVersion: '2024-02-01'
  }
};
